import "./App.css";
import "@google/model-viewer";
import React, { useState, useEffect } from "react";
import ModelViewer from "./components/ModelViewer";
import SplashScreen from "./components/SplashScreen";
import ErrorPage from "./components/404";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import DRI from "./assets/DRILogo.jpeg";
import axios from "axios";

function App() {
  const [modelUrl, setModelUrl] = useState("");
  const [modelType, setModelType] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const userId = urlParams.get("userId");
    const assetId = urlParams.get("assetId");
    const modelTypeParam = urlParams.get("modelType");

    if (!userId || !assetId) {
      setError("Missing userId or assetId in URL.");
      setLoading(false);
      return;
    }

    const isUserIdNumeric = /^\d+$/.test(userId);

    if (isUserIdNumeric) {
      axios
        .get(`https://jsonplaceholder.typicode.com/users/${userId}`)
        .then((res) => {
          console.log("User data loaded:", res.data);

          const encodedPath = `partners%2F${userId}%2F${assetId}.glb`;
          const firebaseUrl = `https://firebasestorage.googleapis.com/v0/b/drinterior-ab7e8.appspot.com/o/${encodedPath}?alt=media`;

          setModelUrl(firebaseUrl);
          setModelType(modelTypeParam || "floor");
          setTimeout(() => setLoading(false), 1000); // Splash delay
        })
        .catch(() => {
          setError("Failed to load user data.");
          setLoading(false);
        });
    } else {
      const encodedPath = `partners%2F${userId}%2F${assetId}.glb`;
      const firebaseUrl = `https://firebasestorage.googleapis.com/v0/b/drinterior-ab7e8.appspot.com/o/${encodedPath}?alt=media`;

      setModelUrl(firebaseUrl);
      setModelType(modelTypeParam || "floor");
      setTimeout(() => setLoading(false), 1000); // Splash delay
    }
  }, []);

  if (loading) return <SplashScreen />;
  if (error) return <ErrorPage message={error} />;

  return (
    <div className="App">
      <div className="model-container">
        <ModelViewer
          src={modelUrl}
          alt="3D Model"
          autoRotate={true}
          cameraControls={true}
          disableZoom={true}
          ar={true}
          arPlacement={modelType}
          arScale="fixed"
          style={{ width: "100%", height: "250px", borderRadius: "30px" }}
        />
      </div>

      <Grid
        container
        direction="column"
        alignItems="center"
        spacing={3}
        style={{ padding: isSmallScreen ? "10px" : "40px" }}
      >
        <Grid
          item
          xs={12}
          className="footer-content"
          style={{ textAlign: "center" }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <img src="/irukkai.jpeg" alt="Logo" className="footer-logo" />
            </Grid>
            <Grid item>
              <Typography variant="subtitle1" component="p" fontWeight="bold">
                Powered By
              </Typography>
              <img src={DRI} alt="DRI Logo" className="powered-logo" />
            </Grid>
          </Grid>
          <Typography variant="caption" display="block" marginTop={2}>
            The displayed models are for visual demonstration purposes only. The
            actual product may differ*
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
